import { useEffect, useRef, useState } from "react";
import InProcessMonitoringViewModel from "../../viewmodels/inProcessMonitoring/inProcessMonitoringViewModel";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import { formatDateWithTime, withRouter } from "../../shared/utility";
import SlideOver from "../../components/slideOver/SlideOver";
import NextInProcessModal from "../../components/inProcessMonitoring/NextInProcessModal";
import EmptyModal from "../../components/modals/EmptyModal";
import StatsComponents from "../../components/stats/StatsComponents";

import { Paginator } from "primereact/paginator";
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";

function InProcessMonitoringHistory(props) {
  const { logout, addSnackbar } = props;
  const {
    getInProcessMonitoringHistories,
    histories,
    loading,
    updateInProcessMonitoringHistory,
    fetchInProcessMonitoringHistoryByProductionId,
    emptyModal,
    setEmptyModelOpen,
    setSlideOver,
    slideOver,
    filters,
    setFilters,
    showDates,
    setShowDates,
    analytics,
    showFilters,
    setShowFilters,
    filterComponents,
    resetFilters,
    fetchRecipesForDropdown,
    getEmployeesForDropdown,
    getCertifiedByOptionsForDropdown,
    fetchProductsForDropdown,
    previousInProcessMonitoringHistory,
  } = InProcessMonitoringViewModel(logout, addSnackbar);

  var currentPage = 1;
  useEffect(() => {
    fetchRecipesForDropdown();
    getEmployeesForDropdown(2, [1, 3]);
    getEmployeesForDropdown(1, [1, 3]);
    getCertifiedByOptionsForDropdown();
    fetchProductsForDropdown();
    getInProcessMonitoringHistories(null, currentPage, filters);
  }, []);

  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(20);

  const searchRef = useRef();

  const handleSearch = () => {
    getInProcessMonitoringHistories(
      searchRef.current.value,
      currentPage,
      filters
    );
  };

  const handlePagination = (event) => {
    currentPage = event.page + 1;
    setFirst(event.first);
    setRows(event.rows);
    getInProcessMonitoringHistories({
      search: searchRef.current.value,
      page: currentPage,
    });
  };

  const handleMoveToNext = async (entry) => {
    if (!entry.next_process_status_id) return;

    const confirmAction = async (entry, employeePin) => {
      // close the modal first
      setEmptyModelOpen({ childComponent: null, open: false });

      // call the viewmodel action with the pin from the form values
      await updateInProcessMonitoringHistory({
        product_id: entry.product_id,
        production_id: entry.production_id,
        current_history_id: entry.id,
        next_in_process_status_id: entry.next_process_status_id,
        pin: employeePin,
      });
    };
    setEmptyModelOpen({
      open: true,
      childComponent: (
        <NextInProcessModal
          buttonMessage="Move"
          // receive pin from modal and forward both entry and pin to the handler
          confirmAction={(pin) => confirmAction(entry, pin)}
          processRecord={entry}
          message={`Move ${
            entry.description_en ? entry.description_en : "this product"
          } to next status: ${entry.next_process_status_name}?`}
          setOpen={setEmptyModelOpen}
          title="Move to next status"
        />
      ),
    });
  };

  const handleMoveToPrevious = async (entry) => {
    if (!entry.previous_process_status_id) return;

    const confirmAction = async (entry, employeePin) => {
      setEmptyModelOpen({ childComponent: null, open: false });

      await previousInProcessMonitoringHistory({
        product_id: entry.product_id,
        production_id: entry.production_id,
        current_history_id: entry.id,
        previous_process_status_id: entry.previous_process_status_id,
        pin: employeePin,
      });
    };
    setEmptyModelOpen({
      open: true,
      childComponent: (
        <NextInProcessModal
          buttonMessage="Move"
          confirmAction={(pin) => confirmAction(entry, pin)}
          processRecord={entry}
          message={`Move ${
            entry.description_en ? entry.description_en : "this product"
          } to previous status: ${entry.previous_process_status_name}?`}
          setOpen={setEmptyModelOpen}
          title="Move to previous status"
        />
      ),
    });
  };

  return (
    <div>
      <div className="mt-2">
        <div className="px-4 sm:px-6 lg:px-8 space-y-2">
          <StatsComponents
            analytics={analytics}
            setFilters={setFilters}
            filters={filters}
            setShowDates={setShowDates}
            showDates={showDates}
            handleSearch={handleSearch}
            filtersEnabled={true}
            showFilters={showFilters}
            filterComponents={filterComponents}
            resetFilters={resetFilters}
            setShowFilters={setShowFilters}
          />
          <div className="sm:flex sm:items-center px-4 py-5 sm:px-4 card-custom">
            <div className="sm:flex-auto">
              <h1 className="text-base font-semibold leading-6 text-gray-900">
                In-Process Monitoring
              </h1>
              <div className="mt-5 flex rounded-md">
                <div className="relative flex items-stretch flex-grow focus-within:z-10">
                  <input
                    type="search"
                    name="searchProduct"
                    id="searchProduct"
                    className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
                    placeholder="Search by name"
                    ref={searchRef}
                    onKeyDown={(e) =>
                      e.key === "Enter" ? handleSearch() : null
                    }
                  />
                </div>
                <button
                  type="button"
                  className="-ml-px relative inline-flex items-center space-x-2 px-4 py-1 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
                  onClick={() => handleSearch()}
                >
                  <MagnifyingGlassIcon
                    className="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </button>
              </div>
            </div>
          </div>
          <div className="mt-8 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                {loading ? (
                  <div>
                    <div className="border h-10 shadow rounded-md p-4 w-full mx-auto">
                      <div className="animate-pulse flex space-x-4">
                        Loading
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="overflow-hidden card-custom">
                    <table className="min-w-full divide-y divide-gray-300">
                      <thead className="bg-white">
                        <tr>
                          <th
                            scope="col"
                            className="py-3 pl-3 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                          >
                            PLU
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Name
                          </th>

                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Lot Number
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Total Weight
                          </th>

                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Production Date
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Current Status
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Next Status
                          </th>
                          <th
                            scope="col"
                            className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                          ></th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {(histories?.data?.length || 0) > 0
                          ? histories.data.map((entry, index) => (
                              <tr key={entry.id}>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {entry.plu}
                                </td>
                                <td className="whitespace-nowrap py-1.5 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                  {entry.description_en}
                                </td>

                                <td className="whitespace-nowrap py-1.5 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                  {entry.lot_number}
                                </td>

                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {entry.weight} kg
                                </td>

                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {formatDateWithTime(entry.production_date)}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                  {entry.in_process_status_name ? (
                                    <button
                                      onClick={() =>
                                        handleMoveToPrevious(entry)
                                      }
                                      className="mr-2 rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-amber-400 filter hover:brightness-110 transition duration-150 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                      style={{
                                        backgroundColor:
                                          entry.in_process_status_color
                                            ? "#" +
                                              entry.in_process_status_color
                                            : "#F59E0B",
                                      }}
                                    >
                                      {entry.in_process_status_name}
                                    </button>
                                  ) : (
                                    <span className="text-gray-500 font-bold"></span>
                                  )}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                  {entry.next_process_status_id ? (
                                    <button
                                      onClick={() => handleMoveToNext(entry)}
                                      style={{
                                        backgroundColor:
                                          "#" + entry.next_process_status_color,
                                      }}
                                      className="mr-2 rounded-md bg-green-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-400 filter hover:brightness-110 transition duration-150 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                    >
                                      {entry.next_process_status_name}
                                    </button>
                                  ) : (
                                    <span className="text-gray-500 font-bold"></span>
                                  )}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                  <button
                                    onClick={() =>
                                      fetchInProcessMonitoringHistoryByProductionId(
                                        entry.production_id
                                      )
                                    }
                                    className="mr-2 rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-main-purple-200 filter hover:brightness-110 transition duration-150 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                  >
                                    Details
                                  </button>
                                </td>
                              </tr>
                            ))
                          : "Empty"}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              <div className="w-full">
                <Paginator
                  first={first}
                  rows={rows}
                  totalRecords={
                    histories?.total || histories?.data?.length || 0
                  }
                  onPageChange={handlePagination}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(InProcessMonitoringHistory)
);
